import Papa from 'papaparse';
import dayjs from 'dayjs';
import axios from '../../../helpers/custom-axios';
import { confirmation, notify } from '../../../helpers/notifications';
import { downloadBlob } from '../../../helpers/downloadBlob';

export const deleteDelivery = async (id, callback) => {
  confirmation.destroy(() => {
    axios
      .delete(`/manage/deliveries/${id}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
};

export const exportDeliveries = (deliveries, subID) => {
  if (deliveries.length === 0) {
    return notify.alertFailure('Uh Oh!', 'No deliveries to export...');
  }
  let exportFormat = deliveries.map((d) => {
    const format = {
      Sent_To: d.to,
      BCC: d.bcc,
      Mailer: d.mailer_name,
      Sent_By: d.sent_by,
      Date_Sent: d.mailed_at
        ? dayjs(d.mailed_at).format('MM/DD/YYYY')
        : 'Not Delivered',
    };
    return format;
  });

  let csv = Papa.unparse(exportFormat);
  let blob = new Blob([csv], { type: 'text/csv' });
  let filename = `Submission_${subID}_Deliveries.csv`;
  downloadBlob(blob, filename);
};
